module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "play_store_badge.0e171c46.png" + "?" + Date.now();